export const FAILED_AVAILABILTY = {
  availableHours: [],
  availableQty: 0,
  bufferQty: 0,
  canReserve: false,
  endDate: '',
  rentalHours: {
    endDateHours: {
      close: '',
      open: ''
    },
    startDateHours: {
      close: '',
      open: ''
    },
    timeZoneId: '',
    weeklyHours: {
      sunday: {
        close: '',
        open: ''
      },
      saturday: {
        close: '',
        open: ''
      },
      tuesday: {
        close: '',
        open: ''
      },
      wednesday: {
        close: '',
        open: ''
      },
      thursday: {
        close: '',
        open: ''
      },
      friday: {
        close: '',
        open: ''
      },
      monday: {
        close: '',
        open: ''
      }
    }
  },
  startDate: '',
  unAvailableHours: []
};